import { render, staticRenderFns } from "./SetAssessFormWrite.vue?vue&type=template&id=8f4b1d84&"
import script from "./SetAssessFormWrite.vue?vue&type=script&lang=js&"
export * from "./SetAssessFormWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports